import React from 'react';
import { Check, Info } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Pricing.css';

const Pricing = () => {
  const pricingPlans = [
    {
      title: 'Bilet Simplu',
      price: '3',
      period: 'călătorie',
      features: [
        'O călătorie validă 90 minute',
        'Transfer între linii permis',
        'Validare digitală',
        'Suport clienți'
      ]
    },
    {
      title: 'Abonament Săptămânal',
      price: '35',
      period: 'săptămână',
      popular: true,
      features: [
        'Călătorii nelimitate 7 zile',
        'Toate liniile incluse',
        'Transfer instant între linii',
        'Suport prioritar',
        'Economie 30%'
      ]
    },
    {
      title: 'Abonament Lunar',
      price: '150',
      period: 'lună',
      features: [
        'Călătorii nelimitate 30 zile',
        'Toate liniile incluse',
        'Transfer instant',
        'Suport VIP 24/7',
        'Economie 50%',
        'Acces la promoții exclusive'
      ]
    }
  ];

  const discounts = [
    { category: 'Studenți', discount: '50%', requirements: 'Legitimație valabilă' },
    { category: 'Pensionari', discount: '50%', requirements: 'Carte identitate' },
    { category: 'Persoane cu dizabilități', discount: '75%', requirements: 'Certificat medical' },
    { category: 'Familii (3+ copii)', discount: '40%', requirements: 'Certificate naștere' }
  ];

  return (
    <div className="pricing-page">
      <section className="pricing-hero">
        <div className="container">
          <h1 className="page-title">Tarife & Abonamente</h1>
          <p className="page-subtitle">
            Alege planul care ți se potrivește și economisește bani
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="pricing-grid">
            {pricingPlans.map((plan, index) => (
              <div key={index} className={`pricing-card card ${plan.popular ? 'pricing-card-popular' : ''}`}>
                {plan.popular && <div className="popular-badge">Cel mai popular</div>}

                <h3 className="pricing-title">{plan.title}</h3>
                <div className="pricing-price">
                  <span className="price">{plan.price}</span>
                  <span className="currency">RON</span>
                  <span className="period">/ {plan.period}</span>
                </div>

                <ul className="pricing-features">
                  {plan.features.map((feature, idx) => (
                    <li key={idx}>
                      <Check size={18} />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <Link to="/bilete" className="btn btn-primary btn-large">
                  Cumpără Acum
                </Link>
              </div>
            ))}
          </div>

          <div className="discounts-section">
            <h2 className="section-title">Reduceri Speciale</h2>
            <div className="discounts-grid">
              {discounts.map((discount, index) => (
                <div key={index} className="discount-card card">
                  <div className="discount-badge">{discount.discount}</div>
                  <h4>{discount.category}</h4>
                  <p>
                    <Info size={16} />
                    {discount.requirements}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
